(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('FactoryDetailController', FactoryDetailController);

    FactoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity'];

    function FactoryDetailController($scope, $rootScope, $stateParams, previousState, entity) {
        var vm = this;

        vm.factory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:factoryUpdate', function(event, result) {
            vm.factory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
